import angular from 'angular';
import components from './components';

export default angular.module('insuranceAppWorkbenchModal.scenes', [components])
  .name;
